const SocialIconLinkedin = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9665 1.98828H2.03347C1.46278 1.98828 1 2.45106 1 3.02175V14.9548C1 15.5255 1.46278 15.9883 2.03347 15.9883H13.9665C14.5372 15.9883 15 15.5255 15 14.9548V3.02175C15 2.45106 14.5372 1.98828 13.9665 1.98828ZM5.17278 13.9155H3.06792V7.22856H5.17278V13.9145V13.9155ZM4.12083 6.303C3.45097 6.303 2.9075 5.79259 2.9075 5.09453C2.9075 4.39648 3.45097 3.88606 4.12083 3.88606C4.79069 3.88606 5.33417 4.39648 5.33417 5.09453C5.33417 5.79259 4.79069 6.303 4.12083 6.303ZM12.9331 13.9213H10.8282V10.2697C10.8282 9.19245 10.3703 8.85995 9.77917 8.85995C9.155 8.85995 8.5425 9.32953 8.5425 10.2969V13.9223H6.43764V7.23342H8.46181V8.15995H8.48903C8.69222 7.7487 9.40389 7.04578 10.4899 7.04578C11.6643 7.04578 12.9331 7.74287 12.9331 9.78453V13.9204V13.9213Z"
        fill="currentColor"
      />
    </svg>
  );
};

export { SocialIconLinkedin };
